/*
 * Loader store: This file stores the dependencies of application loader.
 * It is a loader store which indicates its type and message.
 */

import { types,ModelInstanceTypeProps ,ModelProperties} from 'mobx-state-tree';
import { CQAppConstant } from '../../app-constants';


/**
 * @description Loader Model Initialization
 */
export const CQActivityLoaderModel = types
    .model({
        activityIndicatorFlag:  types.optional(types.boolean,false),
        loaderMessage: types.optional(types.string, ''),
        showDeployementStatus:types.optional(types.boolean,false),
        loaderMessageStatus: types.optional(types.boolean,false),
    })
    .actions((self: ModelInstanceTypeProps<ModelProperties>)  => ({
        setVisibility(status: boolean, message?: string,showDeployementStatus=false, loaderMessageStatus=false) {
            self.activityIndicatorFlag = status;
            self.loaderMessage = message
                ? message
                : CQAppConstant.LOADING_TEXT_DEFAULT; 
            self.showDeployementStatus = showDeployementStatus;
            self.loaderMessageStatus= loaderMessageStatus;
        }
    }));
